<template>
  <div style="height:100vh;">
    <div v-wechat-title="$route.meta.title=docTitle"></div>
    <div class="top" v-if="actData">
      <liveTop :compMsg="actData" v-if="actData.company"></liveTop>
      <liveRank v-if="false&&actData.exhibitorId"></liveRank>
      <div class="live 22222222">
        <!-- <div class="live-content"></div> -->
        <!-- <div class="live-layer"></div> -->
        <van-swipe class="my-swipe" indicator-color="white" :autoplay="isAutoplay" @change="swiperChange">
          <van-swipe-item v-if="videos && videos.url">
            <videoPlayer ref="videoPlays" @onPlayerPlay="onVideoPlay" @onPlayerPause="onVideoPause" :url="videos.url" :cover="videos.cover"></videoPlayer>
          </van-swipe-item>
          <van-swipe-item v-for="(item,index) in banner" :key="index">
            <img :src="item" preview="2" :large="item" style="width: 100%;height: 100%" v-load="'oTopicBanner'">
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="list">
        <div class="list-title">
          <div class="list-title-txt">{{(actData.isExhibitionActivity?actData.titleEn: actData.title)||'' }}</div>
          <!-- <div class="list-title-txt2" :class="isLike ? 'list-title-txt2-active' : ''">
            <i class="icon iconfont icon-dianzanxuanzhong"></i>
            {{this.$service.getCount(actData.likeCount)}}
          </div> -->
        </div>
        <!-- 主办时间 -->
        <div class="list-main" v-if="!actData.exhibitorId">{{actData.startTime | moment('MM/DD HH:mm')}}~{{actData.endTime | moment('HH:mm')}}</div>
        <!-- 展商活动时间 -->
        <div class="list-main" v-else>{{actData.startTime | moment('MM/DD HH:mm')}}~{{actData.endTime | moment('MM/DD HH:mm')}}</div>
      </div>
    </div>

    <div class='tab-nav'>
      <span v-for="(item,index) in typeList" :key="index" @click="typeIndex = index" :class="typeIndex == index ? 'typeActive': ''">{{item}}</span>
    </div>
    <div class="content2" v-if="typeIndex === 0">
      <!-- 互动交流需固定高度 -->
      <liveContact id="barrage" ref="barrage"></liveContact>
    </div>
    <liveDate v-if="actData&&typeIndex == 1" :introduction="introduction" :actData="actData" :isLive="false"></liveDate>
    <liveFollow v-if="typeIndex == 2" :islike="isLike" @addlike="sendHandle" ref="follow"></liveFollow>
    <!-- :userCount="actData.userCount"  -->
    <!-- :likeCount="actData.likeCount" -->
    <talk @sendHandle="sendHandle" @watchliveSend="send" :type="'nolive'" :islike="isLike" :isLove="isFollow"></talk>
    <!-- <actfooter v-if="actData" :isLike="isLike" :isFollow="isFollow" @sendHandle="sendHandle" :actData="actData" :exhibitorId="actData.exhibitorId" :type="'nolive'"></actfooter> -->

    <!-- 预约洽谈 -->
    <order ref="order"></order>
    <liveShare ref="liveShare"></liveShare>
  </div>
</template>

<script>
import { Dialog } from "vant";
// import liveModule from "./components/live-module";
// import liveLangChoice from "./components/live-lang-choice";
import liveContact from "./components/live-contact";
// import liveGift from "./components/live-gift";
import talk from "./components/talk";
// import liveTool from "./components/live-tool";
import liveDate from "./components/live-date";
// import liveHot from "./components/live-hot";
// import liveOnline from "./components/live-online";
// import livePic from "./components/live-pic";
// import liveTalk from "./components/live-talk";
// import liveAct from "./components/live-act";
import liveTop from "./components/live-top";
import liveRank from "./components/live-rank";
// import helpMoney from "@/components/help-money";
import liveFollow from "./components/live-follow";
import liveShare from "@/components/live-share/index";
import hot from "./components/goHot";
import videoPlayer from "../exhibition-invitation/components/videoPlayer";
// import actfooter from "./components/footer";
import order from "@components/order-model.vue"; // 预约洽谈
import { Swipe, SwipeItem } from "vant";
import { mapActions, mapGetters } from "vuex";
import gql from "graphql-tag";
import * as signalR from "@microsoft/signalr";

export default {
  name: "activity",
  data () {
    return {
      showLang: false,
      showGift: false,
      curIndex: 0,
      actData: null,
      isLike: false, // 点赞
      isFollow: false, // 围观
      banner: [],
      videos: null,
      autoPlayVal: 3000,
      isAutoplay: 3000, //是否自动播放
      regMsg: {}, // 开启报名的信息
      hub: null,
      docTitle: "Activity",
      shareV: {
        content: "",
        poster: "",
      },
      typeList: ["Chat", "Introduction", "Visitors"],
      typeIndex: 0,
      introduction: [],
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userInfo: "getUserInfo",
      api: "getApi",
      viewer: "getViewer",
      viewerId: "getViewerId",
      exhibitionConfig: "getExhibitionConfig",
    }),
    query () {
      return this.$router.history.current.query;
    },
    roomid () {
      return this.query.actId;
    },
    ActDetailsGql () {
      // 查询活动详情
      return gql`query activity($id: Guid!){
            activity(id: $id){
                anonymousView
                acvitityType
                banners
                introduction
                introductionEn
                company{
                  name
                  nameEn
                  id
                  logo
                }
                endTime
                exhibitor{
                  id
                  boothHall
                  boothInfo
                }
                exhibitionId
                exhibitorId
                externalLink
                followCount
                id
                startTime
                stateIndex
                title
                titleEn
                userCount
                likeCount
                videos
                viewCount
                isFollow(userId:"${this.userInfo.userId}")
                isLike(userId:"${this.userInfo.userId}")
                hasReg(userId:"${this.userInfo.userId}")
                regStartAt
                regEndAt
                regFee
                regMaximum
                showLiveImage
                showPopularize
                showSchedule
                showTheme
                enabledGift
                enabledBuyingTicket
                isExhibitionActivity  # 是否为主题活动
            }
          }`;
    },
    isRegOk () {
      return this.userInfo && this.userInfo.inMember && this.userInfo.inMember.userRole && this.userInfo.inMember.userRole != "VISITOR" && this.userInfo.inMember.userRole != "Visitor";
    },
    hasUserInfo () {
      return this.userInfo && this.userInfo.userId ? true : false;
    },
  },
  created () {
    document.title = "直播中";
    this.init();
    this.$Myapollo.addExhibitionView();
  },
  mounted () {
    this.$preview.on("imageLoadComplete", (e, item) => { });
  },
  components: {
    Swipe,
    SwipeItem,
    // liveModule,
    // liveLangChoice,
    liveContact,
    // liveGift,
    // liveTool,
    liveDate,
    // liveOnline,
    // liveHot,
    // livePic,
    // liveTalk,
    // liveAct,
    talk,
    liveTop,
    liveRank,
    // helpMoney,
    liveFollow,
    liveShare,
    hot,
    videoPlayer,
    // actfooter,
    order,
  },
  methods: {
    ...mapActions({
      addActFollower: "act/addActFollower",
      addActZan: "act/addActZan",
      delActZan: "act/delActZan",
      addActLove: "act/addActLove",
      delActLove: "act/delActLove",
      addViewLikeIp: "addViewLikeIp",
      addViewLikeIpByCountry: "addViewLikeIpByCountry",
      LinkExInvitation: "linkTo/LinkExInvitation",
      shareToWechat: "wxShare/shareToWechat",
      LinkHotPub: "linkTo/LinkHotPub",
      LinkToActReg: "linkTo/LinkToActReg",
      LinkToActBuy: "linkTo/LinkToActBuy",
      LinkToError: "linkTo/LinkToError",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      generateShareTemplate: "wxShare/generateShareTemplate", //关键字替换
      LinkFooter: "linkTo/LinkFooter",
      graphqlPostByZXS: "en/graphqlPostByZXS",
      LinkToReg: 'linkTo/LinkToReg',
    }),
    //轮播改变
    swiperChange (index) {
      if (this.isAutoplay == "-") {
        //如果改变的时候视频正在播放，则暂停
        this.$refs.videoPlays.swiperChange();
        this.isAutoplay = this.autoPlayVal;
      }
    },
    //视频播放
    onVideoPlay () {
      this.isAutoplay = "-";
    },
    //视频暂停
    onVideoPause (index) {
      this.isAutoplay = this.autoPlayVal;
    },
    async sendHandle (name) {
      if (name === "home") {
        let opt = {
          url: `/home/${this.exhibitionId}`,
        };
        this.LinkFooter(opt);
      }
      if (name === "collect") {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        if (this.isFollow) {
          // 已关注取消关注
          let body = {
            activityId: this.query.actId,
            userId: this.userInfo.userId,
          };
          this.delActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Cancel");
        } else {
          // 未关注添加关注
          let body = {
            exhibitionId: this.exhibitionId,
            activityId: this.query.actId,
            userId: this.userInfo.userId,
            nickName: this.userInfo.nickName || this.userInfo.name,
            avatarUrl: this.userInfo.avatarUrl,
          };
          this.addActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Followed");
        }
      }
      if (name === "zan") {
        let body = {
          targetType: "activity",
          targetId: this.query.actId,
          actionType: "like",
        };
        let res = null;
        if (this.userInfo) {
          if (this.isLike) {
            // 已点赞取消点赞
            this.$toast("You have already Like！");
            return;
          } else {
            // 未点赞添加点赞
            let body = {
              exhibitionId: this.exhibitionId,
              activityId: this.query.actId,
              userId: this.userInfo.userId,
              nickName: this.userInfo.nickName || this.userInfo.name,
              avatarUrl: this.userInfo.avatarUrl,
              number: 1,
            };
            await this.addActZan(body);
            this.isLike = !this.isLike;
            this.$toast.success("success");
            if (this.userInfo.country) {
              body.country = this.userInfo.country;
              res = await this.addViewLikeIpByCountry(body);
            }
          }
        } else {
          res = await this.addViewLikeIp(body);
        }
        if (res && res.result) {
          this.$toast.success("success");
        } else {
          this.$toast.fail("Like failed");
        }
      }
      if (name === "us") {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          let opt = null;
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId, opt);
        } else if (this.userInfo && this.userInfo.inMember.isBlacklist) {
          this.$toast.fail("You do not have access");
          return;
        } else {
          this.$refs.order.open();
        }
      }
      if (name === "share") {
        this.share();
      }
      if (name === "close") {
        let opt = {
          url: `/activity/${this.exhibitionId}`,
        };
        this.LinkFooter(opt);
      }
    },
    //分享点击
    async share () {
      let opt = {
        title: "Recommend an activity for you",
        bannerTitle: this.actData.title, //公司名字
        subhead: "",
        banner: this.banner,
        type: "act",
      };
      this.$nextTick(() => {
        this.$refs["liveShare"].open(opt);
      });
      await true;
    },
    // 右侧工具栏操作
    toolTouch (type) {
      if (type === "ting") {
        // 链接邀请函
        if (this.actData.company && this.actData.company.id) {
          // 展商活动
          this.LinkExInvitation({
            companyId: this.actData.company.id,
            exhibitorId: this.actData.exhibitorId,
            exhibitionId: this.actData.exhibitionId,
          });
        } else {
          // 主办活动
          this.$toast("该活动为主办活动");
        }
      }
      if (type === "talk") {
        console.log("交流");
      }
      if (type === "join") {
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
          return;
        }
        // if(this.actData.hasReg){
        //   this.$toast('您已报名')
        //   return
        // }
        this.LinkToActReg(this.roomid);
      }
      if (type === "order") {
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
          return;
        }
        this.LinkToActBuy(this.roomid);
      }
      if (type === "gift") {
        // 礼物
        this.showGift = true;
      }
      if (type === "hot") {
        // 上热榜
        this.$refs["hot"].open("上热榜");
      }
      if (type === "public") {
        // 发布话题
        if (!this.userInfo.phone) {
          this.$Myapollo.unverifiedDialog(this);
          return;
        }
        if (this.actData.exhibitorId) {
          // 展商活动
          this.LinkHotPub({ id: this.query.actId, talkId: false });
        } else {
          // 主办活动
          this.LinkHotPub({ id: this.exhibitionId, talkId: false });
        }
      }
      if (type === "live") {
        // 上直播
        this.$refs["hot"].open("上直播");
      }
    },
    async init () {
      let body = {
        targetType: "activity",
        targetId: this.query.actId,
        actionType: "view",
      };
      if (this.userInfo && this.userInfo.country) {
        body.country = this.userInfo.country;
        this.addViewLikeIpByCountry(body);
      } else {
        this.addViewLikeIp(body);
      }
      // this.addViewLikeIp(body);
      this.getActDetails();
      this.getUserInit();
      this.checkForm(); // 分享记录数据添加
      this.getHub();
      if (localStorage.getItem("relepase")) {
        localStorage.setItem("relepase", "");
      }
      if (localStorage.getItem("Upimg")) {
        localStorage.setItem("Upimg", "");
      }
      if (localStorage.getItem("content")) {
        localStorage.setItem("content", "");
      }
    },
    getUserInit () {
      if (!this.userInfo) return;
      // this.getIslike();
      this.getIsFollow();
    },
    async getIslike () {
      let query = `
            query($activityId: Guid!,$userId: String!){
              activityLikeQuery{
                isLike(activityId: $activityId,userId: $userId)
              }
            }`;
      let opt = {
        query: query,
        variables: {
          activityId: this.query.actId,
          userId: this.userInfo.userId,
        },
      };
      let res = await this.graphqlPostByZXS(opt);
      if (res.data.activityLikeQuery) {
        this.isLike = res.data.activityLikeQuery.isLike;
      }
    },
    async getIsFollow () {
      let query = `
            query($activityId: Guid!,$userId: String!){
              activityFollowQuery{
                isFollow(activityId: $activityId,userId: $userId)
              }
            }`;
      let opt = {
        query: query,
        variables: {
          activityId: this.query.actId,
          userId: this.userInfo.userId,
        },
      };
      let res = await this.graphqlPostByZXS(opt);
      if (res.data.activityLikeQuery) {
        this.isFollow = res.data.activityLikeQuery.isFollow;
      }
    },
    getActDetails () {
      this.$apollo.addSmartQuery("activity", {
        query: this.ActDetailsGql,
        variables: {
          id: this.query.actId,
        },
        fetchPolicy: "no-cache",
        result (res) {
          console.log('activityactivity:', res.data.activity);
          if (res.data.activity) {
            this.actData = res.data.activity; 
            if (!this.exhibitionConfig) { 
              this.$Myapollo.getExhibitionInfo(this, this.exhibitionId);
            }
            console.log(' : hasUserInfo', this.hasUserInfo);
            console.log('showRegConfirm: anonymousView', this.actData.anonymousView);
            console.log('showRegConfirm: isRegOk', this.isRegOk);
            if (this.actData && !this.actData.anonymousView) { // 有活动信息且不允许匿名观看
              if (!this.hasUserInfo) {// 没有用户信息
                this.showRegConfirm(); // 用户未登录或已登录但没手机号 且活动没有开启匿名观看 弹窗提示“请注册后观看“
              } else {
                if (!this.isRegOk) { // 有用户信息 且没有在当前展会下注册 则跳转j
                  this.showRegConfirm2(); // 用户未登录或已登录但没手机号 且活动没有开启匿名观看 弹窗提示“请注册后观看“
                }
              }
            }
            // this.actData.introductionEn='When it comes to a secure website and passwords it is all in your hands to create a password that a hacker simply cannot crack. However, this will require that you be creative and use everything at your fingertips to create the strongest password possible for a secure web site'
            this.isLike = this.actData.isLike;
            this.isFollow = this.actData.isFollow;
            if (this.actData.banners.indexOf("[") != -1) {
              this.banner = JSON.parse(this.actData.banners);
            } else {
              this.banner = [this.actData.banners];
            }
            if (this.actData.videos) {
              this.videos = JSON.parse(this.actData.videos);
            }
            if (
              this.actData.introduction &&
              this.actData.introduction.indexOf("[") !== -1
            ) {
              this.introduction = JSON.parse(this.actData.introduction);
            } else if (this.actData.introduction) {
              let arr = [
                {
                  text: {
                    type: 1,
                    content: this.actData.introduction,
                    fontSize: "14px",
                    color: "#000",
                    position: "left",
                  },
                },
              ];
              this.introduction = arr;
            }
            // console.log(this.introduction,'this.introductionthis.introductionthis.introduction')
            this.regMsg = {
              regStartAt: this.actData.regStartAt,
              regEndAt: this.actData.regEndAt,
              regFee: this.actData.regFee,
              regMaximum: this.actData.regMaximum,
            };
            this.docTitle =
              (this.actData.isExhibitionActivity
                ? this.actData.titleEn
                : this.actData.title) || "Activity";
            this.getShareVal();
            this.$store.commit("setExhibitionId", this.actData.exhibitionId);
            if (this.actData.exhibitorId) {
              this.$store.commit(
                "company/setExhibitorId",
                this.actData.exhibitorId
              );
            }
          } else {
            this.LinkToError();
          }
        }, // 错误处理
        error (error) {
          console.error(error, "error错误处理");
        },
      });
    },
    // 获取自定义分享
    async getShareVal () {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.activity.en.config",
      });
      if (res) {
        let shareMsg = JSON.parse(res);
        let objTemp = {
          act: this.actData.title,
          CompanyName: this.actData.company ? this.actData.company.nameEn : "",
          booth: this.actData.exhibitor ? this.actData.exhibitor.boothInfo : "",
        };
        let opt = {
          temp: shareMsg.content,
          objTemp: objTemp,
        };
        let optdes = {
          temp: shareMsg.des,
          objTemp: objTemp,
        };
        let msg = await this.generateShareTemplate(opt);
        let des = await this.generateShareTemplate(optdes);
        shareMsg.content = msg;
        shareMsg.des = des;
        this.shareV = shareMsg;
      }
      // 活动的分享配置
      let shareData = {
        title:
          this.shareV && this.shareV.content
            ? this.shareV.content
            : "Recommend an activity for you",
        desc:
          this.shareV && this.shareV.des ? this.shareV.des : this.actData.title,
        imgUrl: JSON.parse(this.actData.banners)[0],
      };
      // console.log('shareD1ata',shareData)
      this.$nextTick(() => {
        this.$refs.liveShare.shareTo(shareData);
      });
      // this.shareToWechat(req);
    },
    checkForm () {
      this.$store.commit("wxShare/setFromType", 4); // 判断是否来源于活动
      let body = {
        activityId: this.query.actId,
        userId: this.userInfo.userId,
      };
      this.$store.commit("wxShare/setFromData", body);
    },
    // 直播
    //用户发送弹幕
    send (text) {
      //  已经进入，得到直播间观众信息
      if (!this.hub) {
        this.$toast.fail("连接失败");
        this.reContact();
        return;
      }
      this.text = text;
      // console.log(this.hub,this.viewer,'发送时');
      if (this.viewer && this.viewerId) {
        var comment = {};
        comment.roomId = this.roomid;
        comment.userId = this.viewer.UserId;
        comment.userInfo = this.viewer.UserInfo;
        comment.viewerId = this.viewerId;
        comment.content = this.text;
        this.hub.invoke("ViewerComment", this.roomid, comment);
      } else {
        //未进入，先进入直播
        console.log("未发送，进入直播");
        this.viewerInit();
      }
    },
    //事件监听
    getLoadMethod () {
      console.log("见町啊");
      //观众进入响应通知
      this.hub.on("ViewerEntryResponseNotice", (msg) => {
        console.log("观众进入响应通知", msg, "msg");
        if (msg.Data.viewer) {
          this.$store.commit("setViewer", msg.Data.viewer);
          this.$store.commit("setViewerId", msg.Data.viewer.Id);
          if (msg.Data.viewer.IsBlack) {
            this.$toast.fail("You have been blocked");
            this.isBlack = true;
          }
          if (this.text) {
            this.send(this.text);
          }
        }
        // 正在直播
        if (msg && msg.Code === 1) {
          that.showBg = false;
          that.liveUrl = msg.Data.pulls[2]; // 直播地址
          that.showBg = true;
        }
        that.liveStatus = msg.Code;
        // that.liveStatus = 3;
        // 直播状态码（LiveCode）：0：未播、1：直播中、2：暂停中、3：已结束、4：已被下架、5：取消、6：未审核通过、7：审核中、8：审核通过
      });
      // 观众进入通知
      this.hub.on("ViewerEntryNotice", (res, onlineCount) => {
        let userinfo = res.UserInfo ? JSON.parse(res.UserInfo) : "";
        let model = {
          id: userinfo.id,
          isEntry: true,
          name: userinfo.nickName || userinfo.name,
          content: "",
        };
        this.$refs["barrage"].viewerEntry(model);
        console.log(res, "观众进入通知");
      });
      // 观众离开通知
      this.hub.on("ViewerLeaveNotice", (msg) => {
        console.log(msg, "观众离开通知");
      });
      // 留言删除通知（留言删除）
      this.hub.on("DeleteLiveCommentNotice", (commentid) => {
        this.$refs["barrage"].delBarrage(commentid);
      });
      // 观众留言通知（留言接收）
      this.hub.on("ViewerCommentNotice", (comment) => {
        let viewerName = "游客";
        if (comment.UserInfo) {
          viewerName =
            JSON.parse(comment.UserInfo).nickName ||
            JSON.parse(comment.UserInfo).name;
        }
        let model = {
          id: comment.Id,
          isEntry: false,
          name: viewerName,
          text: comment.Content,
        };
        console.log(model, "观众留言通知");
        this.$refs["barrage"].dataPush(model);
      });
      // 观众留言响应通知
      this.hub.on("ViewerCommentResponseNotice", (res) => {
        console.log("发送留言， 响应", res);
        //已授权
        // if (!res.Result) {
        //   switch (this.liveStatus) {
        //     case 0:
        //       this.$toast.fail("直播尚未开始");
        //       break;
        //     case 1:
        //       this.$toast.fail(res.Message);
        //       break;
        //     case 2:
        //       this.$toast.fail("直播已经结束");
        //       break;
        //     case 3:
        //       this.$toast.fail("主播暂时不在");
        //       break;
        //     default:
        //       this.$toast.fail(res.Message);
        //       break;
        //   }
        // }
      });
    },
    //建立连接
    getHub () {
      this.$store.commit("setRoomId", this.roomid);
      let roomId = "roomId=" + this.roomid;
      this.hub = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(`${this.api.liveApi}/hub/live?${roomId}`)
        .build();
      // 连接回调
      this.hub
        .start()
        .then((e) => {
          console.log(this.hub, "连接成功");
          this.viewerInit();
          this.getLoadMethod();
          // this.reContact(); // 超时重新连接
        })
        .catch((errorMsg) => {
          console.log(errorMsg, "err");
        });
    },
    // 重新连接
    reContact () {
      const that = this;
      (function (err) {
        setTimeout(() => {
          that.getHub();
        }, 200);
      });
    },
    // 观众进入
    viewerInit () {
      if (!this.userInfo) return; // 没有用户信息
      let viewerInfo = {};
      viewerInfo.roomId = this.roomid;
      viewerInfo.userId = this.userInfo.userId;
      viewerInfo.memberId = this.userInfo.id;
      let model = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        userId: this.userInfo.userId,
        avatarUrl: this.userInfo.avatarUrl,
      };
      viewerInfo.userInfo = JSON.stringify(model);
      console.log(viewerInfo, "viewinfo");
      this.hub.invoke("ViewerEntry", this.roomid, viewerInfo);
    },
    statechange (e) {
      console.log(e);
    },
    //观众离开
    close () {
      if (this.userId && this.userInfo) {
        console.log("离开");
        this.hub.invoke("ViewerLeave", this.roomid, this.userId);
      }
    },
    ready () {
      console.log("ready");
    },
    play () {
      console.log("play");
      this.showBg = false;
    },
    ended () {
      console.log("ended");
      this.showBg = true;
    },
    liveStreamStop () {
      console.log("liveStreamStop");
      this.showBg = true;
    },

    error () {
      console.log("error");
      this.showBg = true;
    },
    // 直播
    showRegConfirm () {
      Dialog.confirm({ message: 'Please log in to watch.', confirmButtonText: 'confirm', cancelButtonText: 'cancel' })
        .then(() => {
          this.regClick();
        })
        .catch(() => {
          console.log('取消');
          this.$router.push(`/activity/${this.exhibitionId}`);
        });
    },
    showRegConfirm2 () {
      Dialog.confirm({ message: 'Please complete the information to watch.', confirmButtonText: 'confirm', cancelButtonText: 'cancel' })
        .then(() => {
          this.regClick();
        })
        .catch(() => {
          console.log('取消');
          this.$router.push(`/activity/${this.exhibitionId}`);
        });
    },
    regClick () {
      console.log('object');
      let opt = {
        originType: "exhibitor",
        originId: this.actData.exhibitorId,
        originRemark: '',
      };
      this.LinkToReg(opt)
    },
  },
  destroyed () {
    this.$store.commit("wxShare/setFromData", null);
    this.$store.commit("wxShare/setFromType", 0);
  },
};
</script>

<style lang="scss" scoped>
.live {
  height: 4.23rem;
  position: relative;
  &-content {
    padding: 10px 15px;
    z-index: 2;
    position: relative;
  }
  &-layer {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3315324068,1694602888&fm=26&gp=0.jpg");
  }
  .my-swipe {
    height: 100%;
  }
}
.list {
  flex-direction: column;
  padding: 15px;
  background: #fff;
  &-title {
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    line-height: 1.5;
    margin-bottom: 8px;
    .my-brand {
      text-align: center;
      margin-right: 4px;
      background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%),
        linear-gradient(#000, #000);
    }
    .dot {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#000, #000);
    }
    .s-gray {
      background: #bfbfbf;
    }
    &-txt {
      display: inline-block;
      max-width: 5rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 10px;
      font-size: 15px;
      color: #333;
      min-height: 0.44rem;
    }
    &-txt2 {
      font-size: 0.22rem;
      color: #666;
      text-align: right;
      display: flex;
      align-items: center;
      background: #f2f2f2;
      border-radius: 3px;
      padding: 5px 5px 5px 3px;
      position: absolute;
      right: 15px;
      height: 0.22rem;
      box-sizing: content-box;
      .icon {
        position: relative;
        top: -1px;
        margin-right: 1px;
      }
      span {
        font-size: 0.22rem;
        position: relative;
      }
    }
    &-txt2-active {
      color: #ff5d00;
      background: rgba(255, 94, 0, 0.1);
    }
  }
  &-main {
    font-size: 13px;
    color: #666;
  }
}
.m-brand {
  background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
    linear-gradient(#000, #000);
  background-blend-mode: normal, normal;
  border-radius: 5px;
  font-size: 9px;
  height: 20px;
  color: #fff;
  display: flex;
  padding: 0 8px;
  display: flex;
  min-width: 60px;
  align-items: center;
  justify-content: center;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #fff;
    border-radius: 50%;
    margin-right: 3px;
  }
}
.content2 {
  height: calc(100vh - 7.34rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
#barrage {
  height: 100%;
  position: relative;
}

.tab-nav {
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f2f2f2;
  border-top: 1px solid #f2f2f2;
  span {
    font-size: 0.26rem;
    position: relative;
  }
  .typeActive {
    color: #0190fe;
  }
  .typeActive::after {
    content: "";
    display: block;
    width: 0.54rem;
    height: 0.04rem;
    background-color: #0190fe;
    border-radius: 0.02rem;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0.1rem;
    margin: auto;
  }
}
</style>
